import React, { useEffect } from 'react'
import './CreateBlog.css'
import ReactQuill from "react-quill";
import "../../../node_modules/react-quill/dist/quill.snow.css";
import { FiUploadCloud } from "react-icons/fi";
import { useState } from 'react';
import { useDispatch } from "react-redux";
import { CreateNewBlogs } from '../../actions/BlogAction';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { WithContext as ReactTags } from 'react-tag-input';
import { mainurl } from '../../actions/mainurl';

const KeyCodes = {
  comma: 188,
  enter: 13
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];


function CreateBlog() {

  const [tags, setTags] = useState([]);

  const handleDelete = i => {
    setTags(tags.filter((tag, index) => index !== i));
  };

  const handleAddition = tag => {
    setTags([...tags, tag]);
  };

  const handleDrag = (tag, currPos, newPos) => {
    const newTags = tags.slice();

    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);

    // re-render
    setTags(newTags);
  };

  const handleTagClick = index => {
    console.log('The tag at index ' + index + ' was clicked');
  };


  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [image, setImage] = useState(null);
  const [defaultImage, setDefaulImage] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [allCategory, setAllCategory] = useState([]);
  const [values, setValue] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [description, setDescription] = useState("");
  const [metaKeyWord, setMetaKeyWord] = useState("");
  const [heading, setHeading] = useState("");
  const [content, setContent] = useState("");
  const [url, setUrl] = useState("");
  const baseurl = mainurl


  // blog image
  const handleImage = (e) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        setDefaulImage(reader.result);
        setImage(e.target.files[0]);
      }
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  // category
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  // react quill funtion
  const handleChange = (e) => {
    setValue(e);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("mainheading", heading);
    formData.append("maincontent", content);
    formData.append("content", values);
    formData.append("meta_description", description);
    formData.append("meta_keywords", metaKeyWord);
    formData.append("meta_title", metaTitle);
    formData.append("imageurl", image);
    formData.append("category", selectedOption);
    formData.append("url", url);
    // Convert tags array to a string before appending it
    const tagsString = JSON.stringify(tags);
    const parsedTags = JSON.parse(tagsString);
    const tagTexts = parsedTags.map(tag => tag.text);
    formData.append("tags", tagTexts);

    console.log(...formData);

    try {
      await dispatch(CreateNewBlogs(formData));
      handleCategory()
      navigate("/allblogs")
    } catch (error) {
      console.error('Error creating new blog:', error);
    }
  }
  const handleCategory = async () => {

    try {
      await axios.post(`${baseurl}/blog/create-category`, { "category": selectedOption }, { withCredentials: true })

    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const { data } = await axios.get(`${baseurl}/blog/get-select-category`, { withCredentials: true });
        setAllCategory(data.value);
      } catch {
        toast.error("Already have category");
      }
    };

    loadCategories();
  }, [baseurl])


  return (
    <div className='create_main_div'>
      <div className='create_div'>
        <form onSubmit={handleSubmit} className='create_div'>
          <div className='input_div'>
            <div className='input_name'>Blog Image</div>
            <label htmlFor="image" className="custom-file-input">
              {<img style={{ position: "relative", zIndex: "5" }} src={image ? defaultImage : defaultImage} alt="" />}
              <FiUploadCloud className='upload_icon' />
            </label>
            <input type="file" onChange={handleImage} name="image" id="image" style={{ display: 'none' }} />
          </div>

          <div className='input_div'>
            <div className='input_name'>Category</div>
            <select className="create_input" value={selectedOption} onChange={handleOptionChange}>
              <option value="">Select page</option>
              {
                allCategory?.map((item) => {
                  return <option key={item} value={item}>{item}</option>
                })
              }
            </select>
          </div>
          <div className='input_div'>
            {
              selectedOption ?
                <>   <div className="input_name">Create a Category</div>
                  <input
                    className="create_input"
                    type="text"
                    value={selectedOption}
                    onChange={(e) => setSelectedOption(e.target.value)}
                  />
                </> :
                <>
                  <div className="input_name">Create a Category</div>
                  <input
                    className="create_input"
                    type="text"
                    value={selectedOption}
                    onChange={(e) => setSelectedOption(e.target.value)}
                  />

                </>
            }
          </div>
          <div className='input_div'>
            <div className='input_name'>Url</div>
            <input className='create_input'
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)} />
          </div>
          <div className='input_div'>
            <div className='input_name'>Tags</div>
            <ReactTags
              tags={tags}
              delimiters={delimiters}
              handleDelete={handleDelete}
              handleAddition={handleAddition}
              handleDrag={handleDrag}
              handleTagClick={handleTagClick}
              inputFieldPosition="bottom"
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              autocomplete
            />
          </div>
          <div className='input_div'>
            <div className='input_name'>Meta Title</div>
            <input className='create_input'
              type="text"
              // placeholder="Enter the meta_title"
              value={metaTitle}
              onChange={(e) => setMetaTitle(e.target.value)} />
          </div>
          <div className='input_div'>
            <div className='input_name'>Meta Description</div>
            <input className='create_input'
              type="text"
              // placeholder="Enter The meta_description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className='input_div'>
            <div className='input_name'>Meta Keyword</div>
            <input className='create_input'
              type="text"
              // placeholder="Enter The meta_keywords"
              value={metaKeyWord}
              onChange={(e) => setMetaKeyWord(e.target.value)}
            />
          </div>
          <div className='input_div'>
            <div className='input_name'>Blog Title</div>
            <input className='create_input' type="text"
              // placeholder="Enter The Heading"
              value={heading}
              onChange={(e) => setHeading(e.target.value)} />
          </div>
          <div className='input_div'>
            <div className='input_name'>Blog Content</div>
            <textarea className='create_text_area'
              type="text"
              // placeholder="Enter some Content..."
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
          </div>
          <div className='input_div'>
            <div className="input_name">Blog details description</div>
            <ReactQuill
              className="text_area"
              placeholder="write some thing"
              formats={CreateBlog.formats}
              modules={CreateBlog.modules}
              value={values}
              onChange={handleChange}
            />
          </div>
          <div className="submit_buttons">
            <input
              type="submit"
              value={"submit"}
              className='create_input_button'
            />
          </div>
        </form>
      </div>
    </div>
  )
};

CreateBlog.modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
};
CreateBlog.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "background",
  "list",
  "bullet",
  "indent",
  "link",
  "video",
  "image",
  "code-block",
  "align",
];

export default CreateBlog;
